import {t} from 'i18next';
import moment from 'moment';
import {FileUpload, SpeedDial} from 'primereact';
import PropTypes from 'prop-types';
import React from 'react';
import {withTranslation} from 'react-i18next';
import { v4 as uuid } from 'uuid';
import BaseDetailsContainer from '../../baseContainers/BaseDetailsContainer';
import ActionButton from '../../components/ActionButton';
import DivContainer from '../../components/DivContainer';
import InputCalendarRangeComponent from '../../components/inputs/InputCalendarRangeComponent';
import InputDropdownComponent from '../../components/inputs/InputDropdownComponent';
import InputNumberComponent from '../../components/inputs/InputNumberComponent';
import InputTextComponent from '../../components/inputs/InputTextComponent';
import InputTextEditorComponent from '../../components/inputs/InputTextEditorComponent';
import YesNoDialog from '../../components/YesNoDialog';
import FileUploadService from '../../services/FileUploadService';
import QuizService from '../../services/QuizService';
import SettingService from '../../services/SettingService';
import AppPrefixUtils from '../../utils/AppPrefixUtils';
import ListUtils from '../../utils/ListUtils';
import EduMaterialComponent from './EduMaterialComponent';
import EduMaterialModel from './EduMaterialModel';
import QuestionComponent from './QuestionComponent';
import QuestionModel from './QuestionModel';
import QuizCreateRequest from './QuizCreateRequest';
import QuizDetailsResponse from './QuizDetailsResponse';
import {withRouter} from 'react-router-dom/cjs/react-router-dom.min';
import ImageComponent from '../../components/inputs/ImageComponent';
import store from '../../store';
import ActionService from '../../services/ActionService';
import InputLanguageDropdownComponent from '../../components/inputs/InputLanguageDropdownComponent';
import InputCheckboxComponent from '../../components/inputs/InputCheckboxComponent';
import PublishToCompaniesDialog from '../../components/PublishToCompaniesDialog';
import PublishedToCompaniesList from '../../components/PublishedToCompaniesList';


class QuizContainer extends BaseDetailsContainer {
    constructor(props) {
        super(props, new QuizService());
        this.fileUploadService = new FileUploadService();
        this.state = {
            steps:[],
            isTourOpen: false,
            loading: true,
            elementId: props.elementId,
            locale: props.locale,
            supportedLocales: [],
            element: props.viewMode === 'NEW' ? new QuizCreateRequest([]) : new QuizDetailsResponse([]),
            quizTypes: [],
            parameters: [],
            showPublishDialog: false,
            showPublishToCompaniesDialog: false,
            showConfirmRemoveDialog: false,
            showConfirmCompleteDialog: false,
            answers:[]
        };
        this.settingService = new SettingService();
        this.fileUploadService = new FileUploadService();
        this.actionService = new ActionService();
        this.descriptionRef = React.createRef();
        this.uploadComponentRef = React.createRef();
        this.introductionRef = React.createRef();
        this.renderLanguages = this.renderLanguages.bind(this);
        this.changeLanguage = this.changeLanguage.bind(this);
        this.reUpdateElement = this.beforeUpdateElement.bind(this);
        this.renderEduMaterials = this.renderEduMaterials.bind(this);
        this.renderQuestions = this.renderQuestions.bind(this);
        this.handleAddQuestion = this.handleAddQuestion.bind(this);
        this.handleRemoveQuestion = this.handleRemoveQuestion.bind(this);
        this.handlePublish = this.handlePublish.bind(this);
        this.handlePublishToCompanies = this.handlePublishToCompanies.bind(this);
        this.handleRemoveAttachmentFromEduMaterial = this.handleRemoveAttachmentFromEduMaterial.bind(this);
        this.publish = this.publish.bind(this);
        this.publishToCompanies = this.publishToCompanies.bind(this);
        this.handleRemoveMaterial = this.handleRemoveMaterial.bind(this);
        this.setAttachmentForEduMaterial = this.setAttachmentForEduMaterial.bind(this);
        this.setAttachmentForQuestion = this.setAttachmentForQuestion.bind(this);
        this.handleRemoveQuestionAttachment = this.handleRemoveQuestionAttachment.bind(this);
        this.createNewAnswerOption = this.createNewAnswerOption.bind(this);
        this.removeAnswerOption = this.removeAnswerOption.bind(this);
        this.onAfterEditAnswerOptions = this.onAfterEditAnswerOptions.bind(this);
        this.onAfterCoinEdition = this.onAfterCoinEdition.bind(this);
        this.moveQuestion = this.moveQuestion.bind(this);
        this.handleRemoveTempFileEduMaterial = this.handleRemoveTempFileEduMaterial.bind(this);
        this.handleRemoveTempFileQuestion = this.handleRemoveTempFileQuestion.bind(this);
        this.anyQuestionWithNoRightAnswer = this.anyQuestionWithNoRightAnswer.bind(this);
        this.uploadPhotoHandler = this.uploadPhotoHandler.bind(this);
        
    }

    translate(key) {
        const {t} = this.props;
        return t(key);
    }

    scroll(node){
        // if (node) {
        //     node.scrollIntoView({
        //       behavior: 'auto',
        //       block: 'center',
        //     });
        //   }
    }
    componentWillUnmount(){
        super.componentWillUnmount();
        store.getState().setQuizForUserActionEnabled(false);
        store.getState().setUserActionsToQuiz([]);
    }
    isRelatedWithAction(){
        const element =  this.state.element;
        return store.getState().quizForUserActionEnabled || element.relatedToAction;
    }
    initSteps(){
        console.log(this.state.element);
        this.steps=[];
       
        this.steps.push({
                    selector: '#type',
                    content: ({ goTo, inDOM }) => (
                        <div>
                          <b>Quiz</b>  - może zawierać materiał, z którym musi zapoznać się użytkownik zanim rozwiąże Quiz (test). <br/>Wyniki są zbierane imiennie. Może być przydatne dla szkoleń itp.
                          <br /><br/>
                          <b>Ankieta</b> - służy do zbierania informacji od użytkowników anonimowo (np. głosowanie)
                        </div>
                      ),
                      style: {
                        backgroundColor: '#cce4fd',
                      },                      
                     
                  });
                  this.steps.push({
                    selector: '#title',
                    content: 'Tytuł dla Quizu lub Ankiety, pojawi się w aplikacji mobilnej obok obrazka',
                    style: {
                             backgroundColor: '#cce4fd',
                    },           
                    
                    });
        this.steps.push({
            selector: '#subject',
            content: ({ goTo, inDOM }) => (
                <div>
                    <b>Temat</b>  - temat Quizu/Ankiety, pojawi się w sekcji <b>Tematyka</b> w aplikacji mobilnej.
                    
                </div>
                ),
                style: {
                  backgroundColor: '#cce4fd',
                },                
                 
            });
        this.steps.push({
                    selector: '#image',
                    content: ({ goTo, inDOM }) => (
                        <div>
                          <b>Zdjęcie</b>  - obrazuje tematykę Quizu/Ankiety.
                          
                        </div>
                      ),
                      style: {
                        backgroundColor: '#cce4fd',
                      },                      
                      
                  });
        this.steps.push({
                    selector: '#description',
                    content: ({ goTo, inDOM }) => (
                        <div>
                          <b>Opis</b>  - znajdzie się w szczegółach Quizu/Ankiety, przed rozpoczęciem.
                          
                        </div>
                      ),
                      style: {
                        backgroundColor: '#cce4fd',
                      },                     
                  });
        if(this.state.element.type?.enumValue=='STANDARD') {  
            this.steps.push({
                selector: '#quizIntroduction',
                content:  ({ goTo, inDOM }) => (
                    <div>
                      <b>Wprowadzenie</b>  - wprowadzenie do Quizu.
                      
                    </div>
                  ),
                  style: {
                    backgroundColor: '#cce4fd',
                  },                  
            });
            this.steps.push({
                selector: '#eduDuration',
                content:  ({ goTo, inDOM }) => (
                    <div>
                      <b>Czas nauki</b>  - szacowany czas zapoznania się z materiałami edukacyjnymi.
                      
                    </div>
                  ),
                  style: {
                    backgroundColor: '#cce4fd',
                  },                  
            });
            this.steps.push({
                selector: '#quizDuration',
                content:  ({ goTo, inDOM }) => (
                    <div>
                      <b>Czas rozwiązania</b>  - szacowany czas roziwązania Quizu.
                      
                    </div>
                  ),
                  style: {
                    backgroundColor: '#cce4fd',
                  },                 
            });
        }
        
        this.steps.push({
                    selector:'#activeFrom-activeTo',
                    content: ({ goTo, inDOM }) => (
                        <div>
                          <b>Aktywność</b>  - data widoczności Quizu/Ankiety w aplikacji mobilnej.
                          
                        </div>
                      ),
                      style: {
                        backgroundColor: '#cce4fd',
                      },                     
                  });

        if(this.state.element.type?.enumValue=='STANDARD') { 
            this.steps.push({
                        selector: '#eduMaterials',
                        content: ({ goTo, inDOM }) => (
                            <div>
                              <b>Materiały edukacyjne</b>  - materiały do zapoznania się przed wypełnieniem Quizu.
                              
                            </div>
                          ),
                          style: {
                            backgroundColor: '#cce4fd',
                          },                          
                      });
        }          
        
        this.steps.push({
                  selector: '#questions',
                  content: ({ goTo, inDOM }) => (
                    <div>
                      <b>Pytania</b>  - dla <b>Quizu</b> należy zaznaczyć, która odpowiedź jest prawidłowa.
                      
                    </div>
                  ),
                  style: {
                    backgroundColor: '#cce4fd',
                  },                  
                });

        
        
    }

    componentDidUpdate(){
        super.componentDidUpdate();
        this.initSteps();
    }

    updateElement(data) {
        const questions = data.translations[this.state.locale]?.questions;
        this.setState(
            {
                uploadedFile: data.quizIcon,
                element: QuizDetailsResponse.copy(data, this.state.supportedLocales),
                questions: questions
            },
            () => {
                this.initAfterSetElement();
            }
        );
    }

    setElement() {
        const {viewMode} = this.props;
        const {elementId, locale} = this.state;
        this.beforeUpdateElement(viewMode, elementId, locale);
        const type=this.state.quizType;
    }

    beforeUpdateElement(viewMode, elementId, locale) {
        this.initSteps();
        if (elementId && (viewMode === 'EDIT' || viewMode === 'VIEW')) {
            this.blockUi();
            this.service
                .get(elementId, locale)
                .then((data) => {
                    this.setState({loading: false, locale}, () => this.updateElement(data));
                })
                .catch((err) => {
                    this.handleGetDetailsError(err);
                });
        } else {
            this.setState({loading: false}, this.initAfterSetElement());
        }
    }


    initBeforeSetElement() {
        this.enumService
            .getLocalizedEnumList('QuizType')
            .then((quizTypes) =>
                this.setState({
                    quizTypes: quizTypes,
                })
            )
            .catch(() => {
                this.showErrorMessage(t('error.getEmaili18nError'));
            });

        this.settingService
            .getSupportedLocales()
            .then((supportedLocales) => {
                this.setState({
                    supportedLocales,
                    element:
                        this.props.viewMode === 'NEW' ? new QuizCreateRequest(supportedLocales) : new QuizDetailsResponse(supportedLocales),
                },()=>{
                    if(this.isRelatedWithAction() && this.props.viewMode === "NEW"){
                        this.handleAddQuestion()
                    }
                });
            })
            .catch(() => {
                this.showErrorMessage(t('error.getSupportedLocalesError'));
            });

        this.settingService
            .getImageSize()
            .then((imgMaxSizeParameter) => {
                this.setState({
                    imgMaxSizeParameter,
                    fileSizeToTranslation: imgMaxSizeParameter * 0.001 + t('global.maxFileSizeUnit'),
                });
            })
            .catch((err) => {
                this.showErrorMessage(err.message);
            });
    }

    getAddSucces() {
        return t('quiz.createSuccess');
    }

    getUpdateSucces() {
        return t('quiz.updateSuccess');
    }

    prepareElementBeforeRequest(element) {
        element.type = element.type?.enumValue;
        if(this.props.viewMode === "NEW"){
            element.relatedToAction = this.isRelatedWithAction()
        }
        return element;
    }
    anyQuestionWithNoRightAnswer() {
        let foundQuestionWithAllWrongAnswers = false;
        const {supportedLocales} = this.state;
        supportedLocales.forEach((element) => {
            const questions = this.state.element.translations[element].questions;

            let foundQustionWithNoRight = false;
            questions.forEach((q) => {
                foundQustionWithNoRight = foundQustionWithNoRight || q.answerOptions.filter((a) => !!a.correct).length === 0;
            });
            foundQuestionWithAllWrongAnswers = foundQuestionWithAllWrongAnswers || foundQustionWithNoRight;
        });
        return foundQuestionWithAllWrongAnswers;
    }

    isNotSurvey() {
        return this.state.element.type?.enumValue !== 'SURVEY';
    }

    handleFormSubmit(event) {
        if (event !== undefined) {
            event.preventDefault();
        }
        if (this.isNotSurvey() && this.anyQuestionWithNoRightAnswer()) {
            this.showErrorMessage(t('quiz.anyQuestionWithNoRightAnswer'));
            return;
        }
        if (this.validator.allValid()) {
            this.blockUi(this.handleValidForm);
        } else {
            this.validator.showMessages();
            // rerender to show messages for the first time
            this.scrollToError = true;
            this.forceUpdate();
        }
    }

    handleComplete(event) {
        if (event !== undefined) {
            event.preventDefault();
        }
        console.log('finish quiz');
        this.setState({
            showConfirmCompleteDialog: true,
        });
        //show confirm dialog
    }

    complete(type, costam, target){
        if (target.value) {
            this.scrollToTop();
            this.service
                .completeQuiz(this.state.elementId)
                .then(() => {
                    const {backUrl} = this.props;
                    this.blockUi();
                    this.persistMessage('success', '', t('quiz.successComplete'));
                    // window.location.href = backUrl;
                    this.props.history.push(AppPrefixUtils.locationHrefUrl(backUrl));
                })
                .catch(() => {
                    this.setState({showConfirmRemoveDialog: false});
                    this.showErrorMessage(t('quiz.removeError'));
                    this.unblockUi();
                });
        } else {
            this.setState({showConfirmCompleteDialog: false});
        }
    }

    createOrUpdate() {
        const {element} = this.state;
        const {elementId, locale} = this.state;
        element.translations = Object.assign({}, element.translations);
        const request = this.prepareElementBeforeRequest(JSON.parse(JSON.stringify(element)));
        this.scrollToTop();
        if (this._isMounted) {
            if (!elementId) {
                this.service
                    .add(request)
                    .then((response) => {
                        this.afterAddSuccess(response);
                    })
                    .catch((err) => {
                        this.props.handleError ? this.props.handleError(err) : this.showErrorMessage(err.message, 10000);
                    });
            } else {
                this.service
                    .update(request, locale, elementId)
                    .then((response) => {
                        this.afterUpdateSuccess(response);
                    })
                    .catch((err) => {
                        this.props.handleError ? this.props.handleError(err) : this.showErrorMessage(err.message, 10000);
                    });
            }
        }
    }

    prepareFooterItems() {
        const {detailUrl, editUrl, locale} = this.props;
        const viewMode = this.viewMode() ? this.viewMode() : this.props.viewMode;
        const editHref = `${editUrl}/${this.state.element?.id}/${locale}`;
        const detailHref = `${detailUrl}/${this.state.element?.id}/${locale}`;
        return [
            {
                label: t('global.save'),
                className: 'float-left',
                onClick: this.handleFormSubmit,
                rendered: viewMode === 'NEW' || viewMode === 'EDIT',
            },
            {
                label: t('global.cancel'),
                // href: AppPrefixUtils.locationHrefUrl(detailHref),
                onClick: () => {
                    this.props.history.push(AppPrefixUtils.locationHrefUrl(detailHref));
                },
                className: 'gray',
                rendered: viewMode === 'EDIT',
            },
            {
                label: t('global.edit'),
                // href: AppPrefixUtils.locationHrefUrl(editHref),
                onClick: () => {
                    this.props.history.push(AppPrefixUtils.locationHrefUrl(editHref));
                },
                iconName: 'mdi-pencil',
                className: 'float-right',
                rendered: this.props.viewMode === 'VIEW' && this.state.element.status?.value === 'DRAFT',
            },
            {
                label: t('quiz.publish'),
                onClick: this.handlePublish,
                className: 'float-right',
                iconName: 'mdi-publish',
                rendered: this.state.element.status?.value === 'DRAFT' && viewMode === 'VIEW',
            },
            {
                label: 'Publikuj do wielu',
                onClick: this.handlePublishToCompanies,
                className: 'float-right',
                iconName: 'mdi-publish',
                rendered:
                    this.state.element.status?.value === 'DRAFT' &&
                    viewMode === 'VIEW' &&
                    this.authService.isUserInRole('ROLE_SUPER_ADMINISTRATOR'),
            },
            {
                label: t('global.remove'),
                onClick: this.handleRemove.bind(this),
                className: 'float-right',
                iconName: 'mdi-delete',
                rendered: (this.props.viewMode === 'VIEW' || this.props.viewMode === 'EDIT') && this.state.element.status?.value === 'DRAFT',
            },
            {
                label: t('quiz.complete'),
                onClick: this.handleComplete.bind(this),
                className: 'float-right',
                iconName: 'mdi-flag-checkered',
                rendered: this.state.element.status?.value === 'ACTIVE' && viewMode === 'VIEW',
            },
        ];
    }

    prepareHeaderItems() {
        const {backUrl} = this.props;
        return [
            {
                customRenderFunction: this.renderLanguages,
                rendered: true,
                className: 'float-left',
            },
            {
                label: t('global.back'),
                // href: AppPrefixUtils.locationHrefUrl(backUrl),
                onClick: () => {
                    this.props.history.push(AppPrefixUtils.locationHrefUrl(backUrl));
                },
                className: 'gray float-right',
                rendered: true,
            },
        ];
    }

    handleRemove() {
        this.setState({
            showConfirmRemoveDialog: true,
        });
    }
    remove(type, costam, target) {
        if (target.value) {
            this.scrollToTop();
            this.service
                .removeQuiz(this.state.elementId)
                .then(() => {
                    const {backUrl} = this.props;
                    this.blockUi();
                    this.persistMessage('success', '', t('quiz.successRemove'));
                    // window.location.href = backUrl;
                    this.props.history.push(AppPrefixUtils.locationHrefUrl(backUrl));
                })
                .catch(() => {
                    this.setState({showConfirmRemoveDialog: false});
                    this.showErrorMessage(t('quiz.removeError'));
                    this.unblockUi();
                });
        } else {
            this.setState({showConfirmRemoveDialog: false});
        }
    }

    handlePublish() {
        this.setState({
            showPublishDialog: true,
        });
    }

    handlePublishToCompanies() {
        this.setState({
            showPublishToCompaniesDialog: true,
        });
    }

    publish(type, costam, target) {
        if (target.value) {
            this.scrollToTop();

            this.blockUi();
            if (this._isMounted) {
                this.service
                    .publish(this.state.elementId)
                    .then(() => {
                        const {backUrl} = this.props;
                        this.blockUi();
                        this.persistMessage('success', '', t('quiz.publishSuccess'));
                        // window.location.href = backUrl;
                        this.props.history.push(AppPrefixUtils.locationHrefUrl(backUrl));
                    })
                    .catch((err) => {
                        this.props.handleError ? this.props.handleError(err) : this.showErrorMessage(err.message, 10000);
                        this.setState({showPublishDialog: false});
                        this.unblockUi();
                    });
            }
        } else {
            this.setState({showPublishDialog: false});
        }
    }

    publishToCompanies(externalIds) {
        this.scrollToTop();
        this.blockUi();
        this.service
            .publishToCompanies(this.state.elementId, {externalIds})
            .then(() => {
                const {backUrl} = this.props;
                this.persistMessage('success', '', 'Quiz zostal opublikowany do wybranych firm.');
                this.props.history.push(AppPrefixUtils.locationHrefUrl(backUrl));
            })
            .catch((err) => {
                this.props.handleError ? this.props.handleError(err) : this.showErrorMessage(err.message, 10000);
                this.setState({showPublishToCompaniesDialog: false});
                this.unblockUi();
            });
    }

    changeLanguage(a, b, c) {
        const {editUrl} = this.props;
        const {elementId} = this.state;
        const locale = c.value;
        // window.location.href = AppPrefixUtils.locationHrefUrl(editUrl + '/' + elementId + '/' + locale);
        this.props.history.push(AppPrefixUtils.locationHrefUrl(editUrl + '/' + elementId + '/' + locale));
        this.beforeUpdateElement('VIEW', elementId, locale);
    }

    renderLanguages() {
        return (
            <InputLanguageDropdownComponent
                id='locale'
                name='locale'
                label={t('global.languageChooser')}
                validator={this.validator}
                validators='not_required'
                value={this.state.locale}
                options={this.state.supportedLocales}
                insideTable
                viewMode={'EDIT'}
                onChange={this.handleChange}
                rendered
                showClear={false}
                stateField={``}
            />
        );
    }

    getBackLabel() {
        return t('global.backToList');
    }
    
    render() {
        return (
            <div className='container-fluid quiz-container'>
                {' '}
                <YesNoDialog
                    onChange={this.publish}
                    visible={this.state.showPublishDialog}
                    header={t('quiz.publishHeader')}
                    name='visible'
                    onHide={() => {
                        this.setState({showPublishDialog: false});
                    }}
                >
                    <span>{t('quiz.publishBody')}</span>
                </YesNoDialog>
                <PublishToCompaniesDialog
                    visible={this.state.showPublishToCompaniesDialog}
                    header='Publikuj quiz do wielu firm'
                    body='Wybierz firmy, do ktorych chcesz opublikowac ten quiz.'
                    onHide={() => {
                        this.setState({showPublishToCompaniesDialog: false});
                    }}
                    onPublish={this.publishToCompanies}
                />
                <YesNoDialog
                    onChange={this.remove.bind(this)}
                    visible={this.state.showConfirmRemoveDialog}
                    header={t('quiz.removeTitle')}
                    name='visible'
                    onHide={() => {
                        this.setState({showConfirmRemoveDialog: false});
                    }}
                >
                    <span>{t('quiz.removeBody')}</span>
                </YesNoDialog>
                <YesNoDialog
                    onChange={this.complete.bind(this)}
                    visible={this.state.showConfirmCompleteDialog}
                    header={t('quiz.completeHeader')}
                    name='confirm'
                    onHide={() => {
                        this.setState({showConfirmCompleteDialog: false});
                    }}
                >
                    <span>{t('quiz.completeBody')}</span>
                </YesNoDialog>
                {this.renderView()}
            </div>
        );
    }
    getContainerListName() {
        return 'quiz-list-container';
    }

    breadCrumbItems() {
        const {t} = this.props;
        const breadCrumbs =[];
        if(this.isRelatedWithAction() && this.props.viewMode === "NEW"){
            const userActionsToQuiz = store.getState().userActionsToQuiz;
            const actionId = userActionsToQuiz[0].actionId;
            breadCrumbs.push({name: t('action.listTitle'), url: `/action-list`})   
            breadCrumbs.push({name: t('user-action.listTitle'), url: `/user-action-list/${actionId}/${this.state.locale}`})   
        }
        breadCrumbs.push({name: t('quiz.listTitle'), url: '/quiz-list'})
        breadCrumbs.push({name: t('quiz.details'), url: `/quiz/edit/${this.state.element?.id}/${this.state.locale}`});
        return breadCrumbs;
    }

    viewMode() {
        const {viewMode} = this.props;
        return viewMode === 'NEW' ? viewMode : this.state?.element?.status?.value === 'DRAFT' && viewMode === 'EDIT' ? 'EDIT' : 'VIEW';
    }
    canViewTour(){
        return this.props.viewMode === 'NEW' || this.props.viewMode === 'EDIT'; 
    }
    renderDetails() {
        const {elementId} = this.state;
        return (
            <React.Fragment>
                <div className='row'>
                    <PublishedToCompaniesList
                        companies={this.state.element?.publishedToCompanies}
                        rendered={this.authService.isUserInRole('ROLE_SUPER_ADMINISTRATOR')}
                    />
                    <div className='col-md-6 col-sm-12'>                      
                        <InputDropdownComponent
                            id='type'
                            name='type'
                            disabled = {this.isRelatedWithAction()}
                            label={t('quiz.type')}
                            optionLabel='label'
                            dataKey='enumValue'
                            validator={this.validator}
                            validators='required'
                            value={this.state.element.type}
                            options={this.state.quizTypes[`${this.state.locale}`]}
                            onAfterStateChange={() => {
                                if (this.state.element.type?.enumValue === 'SURVEY') {
                                    this.setState((prevState) => ({
                                        element: {
                                            ...prevState.element,
                                            eduDuration: 0,
                                            quizDuration: 0
                                        }
                                    }));
                                } else {
                                    this.setState((prevState) => ({
                                        element: {
                                            ...prevState.element,
                                            eduDuration: 15,
                                            quizDuration: 15
                                        }
                                    }));
                                }
                            }}
                            colClass='col-lg-6 col-md-12 col-sm-12'
                            onChange={this.handleChange}
                            viewMode={this.viewMode()}
                            enumMode={true}
                        />
                          <InputNumberComponent
                        id='winnerPoints'
                        name='winnerPoints'
                        label={t('quiz.winnerPoints')}
                        colClass='col-md-6'
                        min={0}
                        value={this.state.element.winnerPoints}
                        validator={this.validator}
                        validators={ this.isRelatedWithAction() ? 'required' : 'not_required'}
                        onChange={this.handleChange}
                        viewMode={this.props.viewMode}
                        rendered={this.isRelatedWithAction()}
                    />
                          <InputTextComponent
                            id='title'
                            name='title'
                            label={t('quiz.title')}
                            colClass='col-md-12'
                            value={this.state.element?.translations[this.state.locale]?.title}
                            validator={this.validator}
                            validators='required|max:200'
                            onChange={this.handleChange}
                            viewMode={this.viewMode()}
                            stateField={`element.translations[${this.state.locale}]`}
                        />
                        <InputTextComponent
                            id='subject'
                            name='subject'
                            label={t('quiz.subject')}
                            colClass='col-md-12'
                            value={this.state.element?.translations[this.state.locale]?.subject}
                            validator={this.validator}
                            validators='required|max:100'
                            onChange={this.handleChange}
                            viewMode={this.viewMode()}
                            stateField={`element.translations[${this.state.locale}]`}
                        />
                    </div>
                    <div className='form-group'>
                        <div className=' row p-label'>
                            <label>{t('quiz.iconLabel')}</label>
                        </div>
                        <ImageComponent
                            key='quiz-photo'
                            srcUrl={`${this.service.getPath()}/quiz-icon/${
                                this.state.element?.quizIcon?.uuid
                            }?token=${this.authService?.getToken()}`}
                            alt='Quiz photo'
                            handleRemove={(e) => {
                                this.setState((prevState) => ({
                                    selectedFile: null,
                                    element: {
                                        ...prevState.element,
                                        quizIcon: null,
                                        removeImage: true,                                       
                                        iconTemporaryFileUrl: null
                                    },
                                }));
                            }}
                            notValidImageTypeErrorMessage={() => {
                                this.showErrorMessage(t('image.notValidImageType'));
                            }}
                            errorMessage={this.showErrorMessage}
                            imgMaxSizeParameter={this.state.imgMaxSizeParameter}
                            fileSizeToTranslation={this.state.fileSizeToTranslation}
                            attachment={this.state.element.quizIcon}
                            setFile={this.uploadPhotoHandler}
                            t={t}
                            required={true}
                            validator={this.validator}
                            viewMode={this.viewMode()}
                            fileUploadService={this.fileUploadService}                            
                        />
                    </div>

                    {/* todo chyba bez obrazków */}
                    <InputTextEditorComponent
                        locale={this.state.locale}
                        colClass='col-xl-12'
                        id='description'
                        key={`description-${this.props.viewMode}`}
                        name='description'
                        value={this.state.element?.translations[this.state.locale]?.description}
                        label={t('quiz.description')}
                        validator={this.validator}
                        validators='required'
                        rows='5'
                        onChange={this.handleChange}
                        viewMode={'EDIT'}
                        disabled={this.props.viewMode === 'VIEW'}
                        autoResize
                        editorRef={this.descriptionRef}
                        externalPhotos={true}
                        photos={this.state.element.photos}
                        photoUrl={`${this.service.getPath()}/photo/${elementId}`}
                        photoUploadUrl={`${this.fileUploadService.getPath()}/`}
                        photoLabel='fileName'
                        photoName='uuid'
                        handleError={this.onUploladError}
                        restrictExt={false}
                        token={this.authService.getToken()}
                        photoVarName='photos'
                        stateField={`element.translations[${this.state.locale}]`}
                    />

                    {this.isNotSurvey() ? (<InputTextEditorComponent
                        colClass="col-xl-12"
                        id={`quizIntroduction`}
                        key={`quizIntroduction-${this.props.viewMode}`}
                        name="quizIntroduction"
                        value={this.state.element?.translations[this.state.locale]?.quizIntroduction}
                        label={t('quiz.quizIntroduction')}
                        validator={this.validator}
                        validators="required"
                        rows="5"
                        onChange={this.handleChange}
                        viewMode={'EDIT'}
                        disabled={this.props.viewMode === 'VIEW' ? true : false}
                        autoResize
                        editorRef={this.introductionRef}
                        externalPhotos={true}
                        photos={this.state.element.photos}
                        photoUrl={`${this.service.getPath()}/photo/${elementId}`}
                        photoUploadUrl={`${this.fileUploadService.getPath()}/`}
                        photoLabel="fileName"
                        photoName="uuid"
                        handleError={this.onUploladError}
                        restrictExt={false}
                        token={this.authService.getToken()}
                        photoVarName="photos"
                        stateField={`element.translations[${this.state.locale}]`}
                    />) : null}

                    <InputNumberComponent
                        id='eduDuration'
                        name='eduDuration'
                        label={t('quiz.eduDuration')}
                        colClass='col-md-6'
                        min={0}
                        value={this.state.element.eduDuration}
                        validator={this.validator}
                        validators={'required'}
                        onChange={this.handleChange}
                        viewMode={this.props.viewMode}
                        rendered={this.isNotSurvey()}
                    />
                    <InputNumberComponent
                        id='quizDuration'
                        name='quizDuration'
                        label={t('quiz.quizDuration')}
                        colClass='col-md-6'
                        min={0}
                        value={this.state.element.quizDuration}
                        validator={this.validator}
                        validators={'required'}
                        onChange={this.handleChange}
                        viewMode={this.props.viewMode}
                        rendered={this.isNotSurvey()}
                    />
                    <InputCalendarRangeComponent
                        id={''}
                        key={'active'}
                        idFrom={'activeFrom'}
                        idTo={'activeTo'}
                        nameTo={'activeTo'}
                        nameFrom={'activeFrom'}
                        label={''}
                        labelFrom={t('quiz.activityRangeFrom')}
                        labelTo={t('quiz.activityRangeTo')}
                        colClass='col-12'
                        from={this.state.element.activeFrom}
                        to={this.state.element.activeTo}
                        validator={[this.validator, this.validatorDraft]}
                        onChange={this.handleChange}
                        viewMode={this.props.viewMode}
                        //minDateFrom={new Date()}
                        showTime
                        showIcon
                        validatorsTo={`required|date|after_or_equal_datetime~${moment(
                            this.state.element.activeFrom ? this.state.element.activeFrom : new Date()
                        )
                            .format('DD-MM-YYYY HH:mm')
                            .toString()}`}
                        placeholderFrom='dd-mm-rrrr GG:MM'
                        placeholderTo='dd-mm-rrrr GG:MM'
                        validateViewMode
                        dateFormatMoment='DD-MM-YYYY HH:mm'
                        validatorsToType='after_or_equal_datetime'
                    />

                    {this.isNotSurvey() ? this.renderEduMaterials() : null}

                    {this.renderQuestions()}

                    <div className='col-md-12'>
                          <InputCheckboxComponent
                                                 id='publicResults'
                                                 rendered={!this.isNotSurvey()}
                                                 name='publicResults'
                                                 label={t('quiz.publicResults')}
                                                 labelOnRight
                                                 value={this.state.element.publicResults}
                                                 validators='not_required'
                                                 colClass={'col-md-4'}
                                                 valueLabel='label'
                                                 validator={this.validator}
                                                 //stateField={this.props.stateField}
                                                 onChange={this.handleChange}
                                                 viewMode={this.props.viewMode}
                                                
                                                 viewLikeDisabled
                                             />
                    </div>

                </div>
            </React.Fragment>
        );
    }

    sleep(ms) {
        return new Promise(resolve => setTimeout(resolve, ms));
    }
    uploadPhotoHandler(uploadedFile) {
        if(uploadedFile != null){
        this.setState((prevState) => ({
            uploadedFile,
            element: {
                ...prevState.element,
                iconTemporaryFileUrl: uploadedFile?.uuid,
            },
        }));
    }
    }

    handleAddMaterial(e) {
        if (e) {
            e.preventDefault();
        }
        const translations = this.state.element.translations;
        const {supportedLocales} = this.state;
        const newUUID = uuid();
        supportedLocales.forEach((element) => {
            const modifiedList = this.state.element.translations[element].eduMaterials;
            modifiedList.push(new EduMaterialModel(modifiedList.length + 1, newUUID));
            modifiedList.forEach((a, i) => (a.order = i + 1));
            translations[element].eduMaterials = modifiedList;
        });

        this.setState((prevState) => ({
            element: {
                ...prevState.element,
                translations,
            },
        }));
    }
    handleAddQuestion(e) {
        if (e) {
            e.preventDefault();
        }
        const translations = this.state.element.translations;
        const {supportedLocales} = this.state;
        const newUUID = uuid();
        supportedLocales.forEach((element) => {
            const modifiedList = this.state.element.translations[element].questions;
            modifiedList.push(new QuestionModel(modifiedList.length + 1, newUUID));
            modifiedList.forEach((a, i) => (a.order = i + 1));
            translations[element].questions = modifiedList;
        });
        this.setState((prevState) => ({
            element: {
                ...prevState.element,
                translations,
            },
        }), ()=>{
            this.createQuestionsFromAction();
        });
    }
    handleRemoveQuestion(e, index) {
        if (e) {
            e.preventDefault();
        }
        const translations = this.state.element.translations;
        const {supportedLocales} = this.state;
        supportedLocales.forEach((element) => {
            const modifiedList = this.state.element.translations[element].questions;
            modifiedList.splice(index, 1);
            modifiedList.forEach((a, i) => (a.order = i + 1));
            translations[element].questions = modifiedList;
        });

        this.setState((prevState) => ({
            element: {
                ...prevState.element,
                translations,
            },
        }));
    }
    createQuestionsFromAction(){
        if(this.isRelatedWithAction() && this.props.viewMode === "NEW"){
            const translations = this.state.element.translations;
            const {supportedLocales} = this.state;
            supportedLocales.forEach((element) => {
                const modifiedList = this.state.element.translations[element].questions;
                const foundQuestion = modifiedList[0];
                if (foundQuestion) {
                    store.getState().userActionsToQuiz.forEach((ua, index)=>{
                        const newObject = {
                            order: index + 1,
                            text: ua.firstName +" "+ ua.lastName,
                            uuid: uuid(),
                            editor: 'TEXT',
                            editable: true,
                            fileUuid: ua.fileUuid,
                            viewMode: this.props.viewMode,
                        };
                        foundQuestion.answerOptions.push(newObject);
                  });
                }
                translations[element].questions = modifiedList;
            });
            this.setState((prevState) => ({
                element: {
                    ...prevState.element,
                    translations,
                },
            }));
        }
    }
    createNewAnswerOption(questionOrderId) {
        const translations = this.state.element.translations;
        const {supportedLocales} = this.state;
        supportedLocales.forEach((element) => {
            const modifiedList = this.state.element.translations[element].questions;

            const foundQuestion = modifiedList.find((m) => m.order === questionOrderId);
            if (foundQuestion) {
                const newObject = {
                    order: foundQuestion?.answerOptions?.length + 1,
                    text: '',
                    uuid: uuid(),
                    editor: 'TEXT',
                    editable: true,
                    viewMode: this.props.viewMode,
                };
                foundQuestion.answerOptions.push(newObject);
            }
            translations[element].questions = modifiedList;
        });

        this.setState((prevState) => ({
            element: {
                ...prevState.element,
                translations,
            },
        }));
    }
    removeAnswerOption(questionOrder, optionOrder) {
        const translations = this.state.element.translations;
        const {supportedLocales} = this.state;
        supportedLocales.forEach((element) => {
            const modifiedList = this.state.element.translations[element].questions;

            const foundQuestion = modifiedList.find((m) => m.order === questionOrder);
            if (foundQuestion) {
                const modifiedOptions = foundQuestion.answerOptions;
                modifiedOptions.splice(optionOrder - 1, 1);
                modifiedOptions.forEach((a, i) => (a.order = i + 1));
                foundQuestion.answerOptions = modifiedOptions;
            }
            translations[element].questions = modifiedList;
        });

        this.setState((prevState) => ({
            element: {
                ...prevState.element,
                translations,
            },
        }));
    }

    handleRemoveMaterial(e, index) {
        if (e) {
            e.preventDefault();
        }
        const translations = this.state.element.translations;
        const {supportedLocales} = this.state;
        supportedLocales.forEach((element) => {
            const modifiedList = this.state.element.translations[element].eduMaterials;
            modifiedList.splice(index, 1);
            modifiedList.forEach((a, i) => (a.order = i + 1));
            translations[element].eduMaterials = modifiedList;
        });

        this.setState((prevState) => ({
            element: {
                ...prevState.element,
                translations,
            },
        }));
    }

    handleRemoveAttachmentFromEduMaterial(e, order) {
        if (e) {
            e.preventDefault();
        }
        const translations = this.state.element.translations;
        const {supportedLocales} = this.state;
        supportedLocales.forEach((element) => {
            const modifiedList = this.state.element.translations[element].eduMaterials;

            const foundMaterial = modifiedList.find((m) => m.order === order);
            if (foundMaterial) {
                foundMaterial.headerPhoto = null;
                foundMaterial.removePhoto = true;
            }
            translations[element].eduMaterials = modifiedList;
        });

        this.setState((prevState) => ({
            element: {
                ...prevState.element,
                translations,
            },
        }));
    }

    handleRemoveQuestionAttachment(e, order) {
        if (e) {
            e.preventDefault();
        }
        const translations = this.state.element.translations;
        const {supportedLocales} = this.state;
        supportedLocales.forEach((element) => {
            const modifiedList = this.state.element.translations[element].questions;

            const foundQuestion = modifiedList.find((m) => m.order === order);
            if (foundQuestion) {
                foundQuestion.headerPhoto = null;
                foundQuestion.removePhoto = true;
            }
            translations[element].questions = modifiedList;
        });

        this.setState((prevState) => ({
            element: {
                ...prevState.element,
                translations,
            },
        }));
    }
    setAttachmentForEduMaterial(order, file) {
        console.log('setAttachmentForEduMaterial', order, file )
        const translations = this.state.element.translations;
        const {supportedLocales} = this.state;
        supportedLocales.forEach((element) => {
            const modifiedList = this.state.element.translations[element].eduMaterials;
            const foundMaterial = modifiedList.find((m) => m.order === order);
            if (foundMaterial) {
                foundMaterial.iconTemporaryFileUrl = file?.uuid;
            }
            translations[element].eduMaterials = modifiedList;
        });

        this.setState((prevState) => ({
            element: {
                ...prevState.element,
                translations,
            },
        }));
    }
    setAttachmentForQuestion(order, file) {
        const translations = this.state.element.translations;
        const {supportedLocales} = this.state;
        supportedLocales.forEach((element) => {
            const modifiedList = this.state.element.translations[element].questions;
            const foundQuestion = modifiedList.find((m) => m.order === order);
            if (foundQuestion) {
                foundQuestion.iconTemporaryFileUrl = file.uuid;
            }
            translations[element].questions = modifiedList;
        });

        this.setState((prevState) => ({
            element: {
                ...prevState.element,
                translations,
            },
        }));
    }

    onAfterEditAnswerOptions(rowData, event, questionOrderId) {
        if (event.target.type === 'checkbox') {
            const translations = this.state.element.translations;
            const {supportedLocales} = this.state;
            supportedLocales.forEach((element) => {
                const modifiedList = this.state.element.translations[element].questions;
                const foundQuestion = modifiedList.find((m) => m.order === questionOrderId);
                if (foundQuestion) {
                    const modifiedAnswers = foundQuestion.answerOptions;
                    const otherAnswers = modifiedAnswers.filter((oa) => oa.order !== rowData.order);
                    const foundAnswer = modifiedAnswers.find((ao) => ao.order === rowData.order);
                    if (foundAnswer) {
                        const correctenessToSet = !foundAnswer.correct;
                        foundAnswer.correct = correctenessToSet;
                        if (correctenessToSet) {
                            otherAnswers.forEach((oa) => {
                                oa.correct = !correctenessToSet;
                            });
                        }
                    }
                    foundQuestion.answerOptions = modifiedAnswers;
                }
                translations[element].questions = modifiedList;
            });
            this.setState((prevState) => ({
                element: {
                    ...prevState.element,
                    translations,
                },
            }));
        }
    }

    onAfterCoinEdition(coinsToEarn, questionOrder) {
        const translations = this.state.element.translations;
        const {supportedLocales} = this.state;
        supportedLocales.forEach((element) => {
            const modifiedList = this.state.element.translations[element].questions;

            const foundQuestion = modifiedList.find((m) => m.order === questionOrder);
            if (foundQuestion) {
                foundQuestion.coinsToEarn = coinsToEarn;
            }
            translations[element].questions = modifiedList;
        });

        this.setState((prevState) => ({
            element: {
                ...prevState.element,
                translations,
            },
        }));
    }

    moveQuestion(indexFrom, indexTo) {
        const translations = this.state.element.translations;
        const {supportedLocales} = this.state;
        supportedLocales.forEach((element) => {
            let modifiedList = this.state.element.translations[element].questions;
            modifiedList = ListUtils.move(modifiedList, indexFrom, indexTo);
            modifiedList.forEach((a, i) => (a.order = i + 1));
            translations[element].questions = modifiedList;
        });

        this.setState((prevState) => ({
            element: {
                ...prevState.element,
                translations,
            },
        }));
    }
    moveEduMaterial(indexFrom, indexTo) {
        const translations = this.state.element.translations;
        const {supportedLocales} = this.state;
        supportedLocales.forEach((element) => {
            let modifiedList = this.state.element.translations[element].eduMaterials;
            modifiedList = ListUtils.move(modifiedList, indexFrom, indexTo);
            modifiedList.forEach((a, i) => (a.order = i + 1));
            translations[element].eduMaterials = modifiedList;
        });

        this.setState((prevState) => ({
            element: {
                ...prevState.element,
                translations,
            },
        }));
    }

    handleRemoveTempFileEduMaterial(a, order) {
        const translations = this.state.element.translations;
        const {supportedLocales} = this.state;
        supportedLocales.forEach((element) => {
            let modifiedList = this.state.element.translations[element].eduMaterials;
            modifiedList.forEach((el) => {
                if (el.order === order) {
                    el.iconTemporaryFileUrl = null;
                }
            });
            translations[element].eduMaterials = modifiedList;
        });

        this.setState((prevState) => ({
            element: {
                ...prevState.element,
                translations,
            },
        }));
    }
    handleRemoveTempFileQuestion(a, order) {
        const translations = this.state.element.translations;
        const {supportedLocales} = this.state;
        supportedLocales.forEach((element) => {
            let modifiedList = this.state.element.translations[element].questions;
            modifiedList.forEach((a, i) => (a.order = i + 1));
            modifiedList.forEach((el) => {
                if (el.order === order) {
                    el.iconTemporaryFileUrl = null;
                }
            });
            translations[element].questions = modifiedList;
        });
        this.setState((prevState) => ({
            element: {
                ...prevState.element,
                translations,
            },
        }));
    }

    renderEduMaterials() {
        return (
            <DivContainer colClass='col-12 ' id='eduMaterials'>
                <div className='title-section-container'>
                    <span className='p-label quiz-section-label'>{t('quiz.materialHeader')}</span>
                </div>
                <div>
                    <div className='row'>
                        <div className='col-12'>
                            <ActionButton
                                label={t('quiz.addMaterialHeader')}
                                className='float-right'
                                key={'next-button'}
                                handleClick={(e) => this.handleAddMaterial(e)}
                                rendered={this.props.viewMode !== 'VIEW'}
                            />
                        </div>
                    </div>
                    <hr id='line-separator' />
                </div>
                {this.state.element?.translations[this.state.locale]?.eduMaterials?.map((material, index) => {
                    return (
                        <div className='reorder-list-container' key={`${index}-edumaterial`}>
                            <div className='reorder-list-controls'>
                                <ActionButton
                                    iconName='mdi-arrow-up-thick'
                                    iconSide='left'
                                    iconColor='white'
                                    handleClick={() => this.moveEduMaterial(index, index - 1)}
                                    rendered={this.viewMode() !== 'VIEW' && index !== 0}
                                />
                                <ActionButton
                                    iconName='mdi-arrow-down-thick'
                                    iconSide='left'
                                    iconColor='white'
                                    handleClick={() => this.moveEduMaterial(index, index + 1)}
                                    rendered={
                                        this.viewMode() !== 'VIEW' &&
                                        index !== this.state.element?.translations[this.state.locale]?.eduMaterials.length - 1
                                    }
                                />
                            </div>
                            <div className='reorder-list-content'>
                                <EduMaterialComponent
                                    locale={this.state.locale}
                                    element={material}
                                    idPrefix={`${index}`}
                                    viewMode={this.viewMode()}
                                    handleChange={this.handleChange}
                                    validator={this.validator}
                                    onErrorMessage={(message) => this.showErrorMessage(message)}
                                    stateField={`element.translations[${this.state.locale}].eduMaterials[${index}]`}
                                    t={this.props.t}
                                    tempUrl={
                                        material?.iconTemporaryFileUrl
                                            ? `${this.fileUploadService.getPath()}/${
                                                  material?.iconTemporaryFileUrl
                                              }?token=${this.authService.getToken()}`
                                            : null
                                    }
                                    handleRemoveTempFileEduMaterial={this.handleRemoveTempFileEduMaterial}
                                    handleRemoveMaterial={this.handleRemoveMaterial}
                                    headerPhotoUrl={`${this.service.getPath()}/quiz-icon/${
                                        material?.headerPhoto?.uuid
                                    }?token=${this.authService.getToken()}`}
                                    handleRemoveAttachment={this.handleRemoveAttachmentFromEduMaterial}
                                    setAttachmentForEduMaterial={this.setAttachmentForEduMaterial}
                                    imgMaxSizeParameter={this.state.imgMaxSizeParameter}
                                    invalidFileSizeMessageDetail={t('global.invalidFileSizeDetails') + this.state.fileSizeToTranslation}
                                    fileSizeToTranslation={this.state.fileSizeToTranslation}
                                />{' '}
                            </div>
                        </div>
                    );
                })}
            </DivContainer>
        );
    }
    renderQuestions() {
        return (
            <DivContainer colClass='col-12' id='questions'>
                <div className='title-section-container'>
                    <span className='p-label quiz-section-label'>{t('quiz.questionsHeader')}</span>
                </div>
                <div>
                    <div className='row'>
                        <div className='col-12'>
                            <ActionButton
                                label={t('quiz.addQuestionHeader')}
                                className='float-right'
                                key={'next-button'}
                                handleClick={(e) => this.handleAddQuestion()}
                                rendered={!this.isRelatedWithAction() && this.viewMode() !== 'VIEW'}
                            />
                        </div>
                    </div>
                    <hr id='line-separator' />
                </div>
                {this.state.element?.translations[this.state.locale]?.questions?.map((question, index) => {
                    return (
                        <div className='reorder-list-container' key={`${index}-question-controls`}>
                            <div className='reorder-list-controls'>
                                <ActionButton
                                    iconName='mdi-arrow-up-thick'
                                    iconSide='left'
                                    iconColor='white'
                                    handleClick={() => this.moveQuestion(index, index - 1)}
                                    rendered={index !== 0 && this.viewMode() !== 'VIEW'}
                                />
                                <ActionButton
                                    iconName='mdi-arrow-down-thick'
                                    iconSide='left'
                                    iconColor='white'
                                    handleClick={() => this.moveQuestion(index, index + 1)}
                                    rendered={
                                        this.viewMode() !== 'VIEW' &&
                                        index !== this.state.element?.translations[this.state.locale]?.questions.length - 1
                                    }
                                />
                            </div>
                            <div className='reorder-list-content'>
                                <QuestionComponent
                                    relatedWithAction={this.isRelatedWithAction()}
                                    locale={this.state.locale}
                                    idPrefix={`${index}`}
                                    element={question}
                                    imageSrcFnc ={(rowData)=>  this.actionService.getPath() + `/user-action/${rowData.fileUuid}/after-photo?token=${this.authService.getToken()}`}
                                    viewMode={this.viewMode()}
                                    handleChange={this.handleChange}
                                    validator={this.validator}
                                    onErrorMessage={(message) => this.showErrorMessage(message)}
                                    rendered={this.state.element.questions !== undefined}
                                    stateField={`element.translations[${this.state.locale}].questions[${index}]`}
                                    handleRemoveQuestion={this.handleRemoveQuestion}
                                    validateViewMode
                                    t={this.props.t}
                                    tempUrl={
                                        question?.iconTemporaryFileUrl
                                            ? `${this.fileUploadService.getPath()}/${
                                                  question?.iconTemporaryFileUrl
                                              }?token=${this.authService.getToken()}`
                                            : null
                                    }
                                    setAttachmentForQuestion={this.setAttachmentForQuestion}
                                    headerPhotoUrl={`${this.service.getPath()}/quiz-icon/${
                                        question?.headerPhoto?.uuid
                                    }?token=${this.authService.getToken()}`}
                                    handleRemoveAttachment={this.handleRemoveQuestionAttachment}
                                    handleRemoveTempFileQuestion={this.handleRemoveTempFileQuestion}
                                    createNewAnswerOption={this.createNewAnswerOption}
                                    removeAnswerOption={this.removeAnswerOption}
                                    onAfterEditAnswerOptions={this.onAfterEditAnswerOptions}
                                    onAfterCoinEdition={this.onAfterCoinEdition}
                                    imgMaxSizeParameter={this.state.imgMaxSizeParameter}
                                    invalidFileSizeMessageDetail={t('global.invalidFileSizeDetails') + this.state.fileSizeToTranslation}
                                    renderAnswerCorrectColumn={this.isNotSurvey()}
                                />
                            </div>
                        </div>
                    );
                })}
            </DivContainer>
        );
    }

}



QuizContainer.defaultProps = {
    backUrl: '/quiz-list',
    editUrl: '/quiz/edit',
    detailUrl: '/quiz/details',
    lazy: true,
};

QuizContainer.propTypes = {
    backUrl: PropTypes.string,
    cancelUrl: PropTypes.string,
    editUrl: PropTypes.string,
};

export default withRouter(withTranslation()(QuizContainer));
